module.exports = __webpack_public_path__ + "static/media/tour-compl-4.9a1af852.png";